/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component, Fragment } from 'react';

import { withStyles, createMuiTheme, ThemeProvider } from '@material-ui/core/styles'
import { Paper, Box, Button, Popper } from '@material-ui/core';
import FlexForm from '../../FlexForm/FlexForm';

const styles = theme => ({
    label: {
        backgroundColor: "white"
    }
})

const clone = require('rfdc')()


class CTAButton extends Component {
    state = {
        cta_config : [],
        open : false,
        anchorEl : null
    }
    componentWillMount () {
        this.setState({...this.state, cta_config: this.props.cta_config})
    }
    executeCTA = (cta_config, record) => {
        //console.log("CTA Executed for record : ", record)
        console.log("CTA Executed for config : ", cta_config)

        let field_maps = cta_config.fields? cta_config.fields : []
        let key_values = []
        field_maps.forEach(fmap => {
            let entry = []
            entry[0] = fmap.field_name

            let value_source = fmap.source.split('.')[0]
            let value_type = fmap.source.split('.')[1]

            if (value_source === 'native') {
                if (value_type === 'raw_field') {
                    entry[1] = record.raw_fields.fields.find(field => field.name === fmap.mapped_to).value
                } else if (value_type === 'world_view') {
                    entry[1] = record.wv_field_list.find(field => field.name === fmap.mapped_to).value.text
                }
            } else if (value_source === 'custom') {
                if (value_type === 'static') {
                  entry[1] = fmap.mapped_to
                }
            }

            key_values.push(entry)
        })

        // let fields = Object.fromEntries(key_values)

        if (cta_config.post_to_parent) {
            let payload = Object.fromEntries(key_values)
            window.parent.postMessage({ message : "Sainapse: CTA", value : JSON.stringify(payload)}, "*")
        } else {
            let query_params = key_values.map(key_value => key_value[0] + "=" + encodeURIComponent(key_value[1]))
            let query_string = query_params.join('&')
            let trigger_url = cta_config.trigger_url + "?" + query_string
            if (cta_config.open_in_new_window) {
                console.log("new window", cta_config.open_in_new_tab)
                window.open(trigger_url, "cta-window", "width=1000,height=800")
            }
            else {
                window.open(trigger_url)
            }           
        } 
    }
    execute_user_input_cta = () =>{
        console.log("popper executed",this.props.cta_config) 
    }

    execute = (event) =>{
        if(this.state.cta_config.user_input.length === 0) {
            this.executeCTA(this.props.cta_config,this.props.record)
        } else {
            const { currentTarget } = event;
            this.setState(state => ({ anchorEl: currentTarget, open: !state.open}),
            this.execute_user_input_cta());
        }
    }

    updateForm = (form) => {
        let cta_config = this.state.cta_config
        cta_config.user_input = form
        console.log('State : ', this.state)
        console.log('updateform :', form)
        this.setState({...this.state,cta_config : cta_config})
    }
    triggerURL=()=>{
        let field_maps = this.props.cta_config.fields ? this.props.cta_config.fields : []
        let key_values = []
        field_maps.forEach(fmap => {
            let entry = []
            entry[0] = fmap.field_name

            let value_source = fmap.source.split('.')[0]
            let value_type = fmap.source.split('.')[1]

            if (value_source === 'native') {
                if (value_type === 'raw_field') {
                    entry[1] = this.props.record.raw_fields.fields.find(field => field.name === fmap.mapped_to).value
                } else if (value_type === 'world_view') {
                    entry[1] = this.props.record.wv_field_list.find(field => field.name === fmap.mapped_to).value.text
                }
            } else if (value_source === 'custom') {
                if (value_type === 'static') {
                  entry[1] = fmap.mapped_to
                }
            }

            key_values.push(entry)
        })

        let field_query_params = key_values.map(key_value => key_value[0] + "=" + encodeURIComponent(key_value[1]))
        let field_query_string = field_query_params.join('&')

        let user_fields = this.state.cta_config.user_input
        let user_query_params = user_fields.map((field) => {
            if(field.value['text'])
                return field.name + "=" + encodeURIComponent(field.value['text'])
            else if (field.value['number'])
                return field.name + "=" + encodeURIComponent(field.value['number'])
            else if (field.value['boolean'])
                return field.name + "=" + encodeURIComponent(field.value['boolean'])
            else if (field.value['list']){
                let query_param = field.name + "="
                query_param = query_param + field.value['list'].map(param => encodeURIComponent(param))
                return query_param
            }
            else {
                return field.name + "="
            }
        })
        let user_query_string = user_query_params.join('&')

        let trigger_url = this.state.cta_config.trigger_url + "?" + field_query_string + "&" + user_query_string
        if (this.state.cta_config.open_in_new_window) {
            console.log("new window", this.state.cta_config.open_in_new_tab)
            window.open(trigger_url, "cta-window", "width=1000,height=800")
        }
        else {
            window.open(trigger_url)
        }
    }

    callPopper=()=>{   
        return(
                <Popper 
                    open = {this.state.open} 
                    anchorEl={this.state.anchorEl} 
                    placement="bottom-end"
                    modifiers={{
                        flip: {
                          enabled: true,
                        },
                        preventOverflow: {
                          enabled: true,
                          boundariesElement: 'scrollParent',
                        }
                    }}
                >
                    <Paper elevation={8} style={{width: this.props.popper_width, height : this.props.popper_height}}>
                        <div style={{ background: '#ffffff', padding:'5px' }}>
                            <Fragment>
                                <FlexForm config={this.props.cta_config.user_input} fields_in_scope={[]} update_parent={(form)=>this.updateForm(form)} submit={(form)=>{}} ></FlexForm>
                            </Fragment>
                            <div style={{display: 'flex', flexDirection: 'row-reverse', padding : '10px'}}>
                                <Button variant = 'outlined' color = 'primary' size = 'small' type = 'button' onClick = {()=>this.triggerURL()}>Submit</Button>
                            </div>    
                        </div>
                    </Paper>
                        
            </Popper>    
        );
    }

    render () {
        return (   
            <div style={{width:'100%', padding :'5px'}}>
                <Button
                    variant = {this.props.style_type ? this.props.style_type : 'contained'}
                    color = 'primary'
                    size = 'small'
                    type = 'button'
                    fullWidth
                    onClick = {(event) => {
                        this.execute(event)
                    }}
                >{this.props.cta_config.button_label}</Button>
                {this.state.cta_config.user_input.length === 0?null:this.callPopper()}
                        
            </div>
            
        );   
    }
}

export default withStyles(styles)(CTAButton);